import {Component, Input} from '@angular/core';

@Component({
    selector: 'nz-image',
    imports: [],
    templateUrl: './image.component.html',
    styleUrl: './image.component.scss'
})
export class ImageComponent {
  @Input() imageUrl!: string;
  @Input() imageAlt!: string;
  @Input() backgroundClass: string = 'bg-body-secondary';
}
